import { createEpic } from "../helpers";

import {
	getPresetItemsListAsyncAction,
	updatePresetItemAsyncAction,
	postPresetItemAsyncAction,
	getPresetItemDetailAsyncAction,
	getPresetDetailAsyncAction,
} from "./presetsActions";

export const getPresetDetailEpic = createEpic(
	getPresetDetailAsyncAction,
	"presets",
	"getPresetDetail",
	true
);

export const getPresetItemsListEpic = createEpic(
	getPresetItemsListAsyncAction,
	"presets",
	"getPresetItemsList",
	true
);

export const getPresetItemDetailEpic = createEpic(
	getPresetItemDetailAsyncAction,
	"presets",
	"getPresetItemDetail",
	true
);

export const postPresetItemEpic = createEpic(
	postPresetItemAsyncAction,
	"presets",
	"postPresetItem",
	true
);

export const updatePresetItemEpic = createEpic(
	updatePresetItemAsyncAction,
	"presets",
	"updatePresetItem",
	true
);
